export default __webpack_public_path__ + "static/media/CarouselBall.ead7a9cc.png";